import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { NavLink } from 'react-router-dom'
import UsePerms from "../../context/userAccess"
import useCompanyData from "../../context/company"

const ICONS = {
    'chart-pie': solid('chart-pie'),
    'table-list': solid('table-list'),
    'pen-to-square': solid('pen-to-square'),
    'users': solid('users'),
    'sitemap': solid('sitemap'),
    'code-branch': solid('code-branch'),
    'fire': solid('fire'),
    'scale-balanced': solid('scale-balanced'),
    'building': solid('building'),
    'wallet': solid('wallet'),
}

function NavItem({ to, end, icon, label }) {
    return (
        <li className="nav-item w-100">
            <NavLink to={to} end={end} className="nav-link align-middle">
                <FontAwesomeIcon className='text-green fs-6' icon={ICONS[icon]} />
                <span className="ms-1 d-none d-sm-inline">{label}</span>
            </NavLink>
        </li>
    )
}

function Section({ title, children }) {
    return (
        <>
            <hr className="border-clean2-dot w-100" />
            <p className="ps-3 mb-1 fw-bold small text-muted text-uppercase d-none d-sm-block">{title}</p>
            <ul className="nav nav-pills flex-column mb-0 align-items-center align-items-sm-start w-100">
                {children}
            </ul>
        </>
    )
}

export default function SidebarCargosSalarios() {
    const VerifyPerms = UsePerms()
    const { rootUser } = useCompanyData()
    const showOrcamento = VerifyPerms(['view_jobposition']) || rootUser

    return (
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 bg-white border-clean side-shadow">
            <div className="d-flex flex-column align-items-center align-items-sm-start px-2 pt-2 min-vh-100">
                <NavLink to="/painel/" className="nav-link text-center mt-3 ms-2">
                    <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                </NavLink>
                <hr className="border-clean2-dot w-100" />
                <p className="mt-1 ps-3 fw-bold d-none d-sm-inline">Cargos & Salários</p>

                <ul className="nav nav-pills flex-column mb-0 align-items-center align-items-sm-start w-100" id="sideMenu">
                    <NavItem to="/cargos-salarios/" end icon="chart-pie" label="Dashboard" />
                </ul>

                <Section title="Operacional">
                    <NavItem to="/cargos-salarios/quadro/" icon="table-list" label="Quadro de Cargos" />
                    <NavItem to="/cargos-salarios/registrar-salarios/" icon="pen-to-square" label="Registrar salários" />
                    <NavItem to="/cargos-salarios/salarios-colaboradores/" icon="users" label="Salários dos colaboradores" />
                </Section>

                <Section title="Análises">
                    <NavItem to="/cargos-salarios/departamentos/" icon="sitemap" label="Por Departamento" />
                    <NavItem to="/cargos-salarios/subempresas/" icon="code-branch" label="Por Organização" />
                    <NavItem to="/cargos-salarios/mapa-calor/" icon="fire" label="Mapa de Calor" />
                </Section>

                <Section title="Comparativos">
                    <NavItem to="/cargos-salarios/comparar-estruturas/" icon="scale-balanced" label="Comparar Estruturas" />
                    <NavItem to="/cargos-salarios/comparar-departamentos/" icon="building" label="Comparar Departamentos" />
                    <NavItem to="/cargos-salarios/comparar-suborganizacoes/" icon="code-branch" label="Comparar Organizações" />
                </Section>

                {showOrcamento && (
                    <Section title="Planejamento">
                        <NavItem to="/cargos-salarios/orcamento/" icon="wallet" label="Orçamento" />
                    </Section>
                )}
            </div>
        </div>
    )
}
